import {
    getOriented,
    triageMyInbox,
    findQuickWins,
    generateProactiveDrafts,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';

export function getEmptyReadingPaneSuggestions(mailboxInfo: MailboxInfo): Suggestions {
    const baseSuggestions: Suggestions = [triageMyInbox, getOriented, findQuickWins];

    // Add "Generate Proactive Drafts" suggestion if the experimental flag is enabled
    // NOTE: this is temporary, throwaway code, to be removed at a later date when the experiment is done
    if (isAccountFeatureEnabled('mon-copilot-proactive-drafts-experimental', mailboxInfo)) {
        // Append as the 4th suggestion instead of replacing an existing one
        baseSuggestions.push(generateProactiveDrafts);
    }

    return baseSuggestions;
}
